import { EventBus, Events, store } from "jiffy-store";
import { api } from "jiffy-api";
import { isFlashPdp } from "components/jiffy/product-details/customizable-made-page-utils";

const fetchInventory = async slug => {
  const { loaded, loading } = store.get(state => ({
    loaded: state.ui.inventoryLoaded,
    loading: state.ui.inventoryLoading
  }));
  if (loaded || loading) return;

  store.ui.change({ inventoryLoading: true });
  const data = await api.jiffyshirts.product.inventory({ slug }, undefined, { cacheable: true });
  window.inventory = data;
  store.ui.change({ inventoryLoaded: true, inventoryLoading: false });
};

export default () => {
  if (isFlashPdp()) return;

  let loading = false;
  store.pdp.changed((state, { data }) => {
    if (!data.isFetchingInventory || loading) return;
    loading = true;

    fetchInventory(state.pdp.fetchingSlug).finally(() => {
      loading = false;
      store.pdp.change({ isFetchingInventory: false });
      EventBus.publish(Events.PRODUCT_INVENTORY_LOADED);
    });
  });
};
